<div class="marginBottomQuarterEm" *ngIf="isLoggedIn && (message !== '')">
    <marquee class="blue italic marginBottomHalfEm" style="width: 100%" behavior="scroll" direction="left">{{ message }}</marquee>
</div>
